// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4223) return "static/chunks/commons-91c96c2a062f19c7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3046 ? "splide" : chunkId) + "." + {"3046":"0846e9ba123f92f9","3219":"ddd5051927c42d3a","8538":"51806211e2ef20de"}[chunkId] + ".js";
};